import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import ReactMarkdown from 'react-markdown';
import CommunityDevelopmentProjects from '../static/ProjectsData/CommunityDevelopment';
import InternationalCooperationProjects from '../static/ProjectsData/InternationalCooperation';
import BusinessAndEnterpreneurshipProjects from '../static/ProjectsData/BusinessAndEnterpreneurship';
import IndividualDevelopmentProjects from '../static/ProjectsData/IndividualDevelopment';
import ImageKit from './ImageKit';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const ProjectDetail = () => {
  const { id, division } = useParams();
  const [markdown, setMarkdown] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  let project;

  switch (division) {
    case "community-development":
      project = CommunityDevelopmentProjects.find(p => p.id === id && p.division === division);
      document.title = `JCI Lucena - ${project?.title || "Project Detail"}`;
      break;
    case "international-cooperation":
      project = InternationalCooperationProjects.find(p => p.id === id && p.division === division);
      document.title = `JCI Lucena - ${project?.title || "Project Detail"}`;
      break;
    case "business-and-entrepreneurship":
      project = BusinessAndEnterpreneurshipProjects.find(p => p.id === id && p.division === division);
      document.title = `JCI Lucena - ${project?.title || "Project Detail"}`;
      break;
    case "individual-development":
      project = IndividualDevelopmentProjects.find(p => p.id === id && p.division === division);
      document.title = `JCI Lucena - ${project?.title || "Project Detail"}`;
      break;
    default:
      document.title = "JCI Lucena - Project Detail";
  }

  useEffect(() => {
    if (project && project.contentPath) { // Matches the JSON key
      fetch(project.contentPath)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load markdown");
          return res.text();
        })
        .then((text) => setMarkdown(text))
        .catch((err) => console.error(err));
    }
  }, [project]);

  if (!project) return <Container className="py-5"><h3>Project not found</h3></Container>;

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
        {/* <Button className="border-0 bg-transparent" onClick={() => navigate('/projects')}><ArrowLeftSquareFill size={30} color='black'/></Button> */}
          {/* 1. Hero Image */}
          {/* <Image 
            src={project.thumbnail} 
            fluid 
            rounded 
            className="mb-4 w-100 shadow" 
            style={{ maxHeight: '450px', objectFit: 'cover' }}
          /> */}

          {/* 2. Title */}
          <h1 className="display-4 fw-bold mb-3">{project.title} </h1>
          <hr className="mb-3" />
          {/* 4. Photo Gallery */}
          <div className='project-detail-swiper'>
            <Swiper
              style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff',
              }}
              spaceBetween={10}
              navigation={true}
              thumbs={{ swiper: thumbsSwiper }} 
              modules={[FreeMode, Navigation, Thumbs]}
              className="project-detail-swiper-main-frame"
            >
              {project.images.map((imgPath, index) => (
                <SwiperSlide key={index}>
                  <ImageKit 
                    path={imgPath.path}
                    ratio={imgPath.aspect}
                    alt={`${project.title} - ${index}`}
                    className="project-image-main-frame"
                    // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <Swiper
              onSwiper={setThumbsSwiper}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              slideToClickedSlide={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className="project-detail-swiper-gallery"
            >
              {project.images.map((imgPath, index) => (
                <SwiperSlide key={index}>
                  <ImageKit 
                    path={imgPath.path}
                    alt={`${project.title} - ${index}`} 
                    // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {/* {project.images && project.images.length > 0 && (
            <div className="mt-5">
              <h3>Gallery</h3>
              <Row className="g-3">
                {project.images.map((img, index) => (
                  <Col xs={6} md={4} key={index}>
                    <Image src={img} fluid rounded thumbnail />
                  </Col>
                ))}
              </Row>
            </div>
          )} */}

          {/* 3. The Formatted Blog Content */}
          <div className="markdown-body mb-5">
            {markdown ? (<ReactMarkdown>{markdown}</ReactMarkdown>) : (<p>Loading project details...</p>)}
          </div>

        </Col>
      </Row>
    </Container>
  );
}

export default ProjectDetail;